module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/007-badd8085752d494f9f1514a944fe33c5.png";